import { render } from "./DeleteParceiroModal.vue?vue&type=template&id=6f8e8964"
import script from "./DeleteParceiroModal.vue?vue&type=script&lang=js"
export * from "./DeleteParceiroModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__